import { getTableLength, getTableRowAsObject } from '@loaders.gl/schema';
import { getGeoMetadata } from "../geo/geoparquet-metadata.js";
export function convertWKBTableToGeoJSON(table, schema, loaders) {
  const geoMetadata = getGeoMetadata(schema);
  const primaryColumn = geoMetadata === null || geoMetadata === void 0 ? void 0 : geoMetadata.primary_column;
  if (!primaryColumn) {
    throw new Error('no geometry column');
  }
  const columnMetadata = geoMetadata.columns[primaryColumn];
  const features = [];
  const length = getTableLength(table);
  for (let rowIndex = 0; rowIndex < length; rowIndex++) {
    const row = getTableRowAsObject(table, rowIndex);
    const geometry = parseGeometry(row[primaryColumn], columnMetadata, loaders);
    delete row[primaryColumn];
    const feature = {
      type: 'Feature',
      geometry: geometry,
      properties: row
    };
    features.push(feature);
  }
  return {
    shape: 'geojson-table',
    schema,
    type: 'FeatureCollection',
    features
  };
}
function parseGeometry(geometry, columnMetadata, loaders) {
  var _wktLoader$parseTextS, _wkbLoader$parseSync;
  switch (columnMetadata.encoding) {
    case 'wkt':
      const wktLoader = loaders.find(loader => loader.id === 'wkt');
      return (wktLoader === null || wktLoader === void 0 ? void 0 : (_wktLoader$parseTextS = wktLoader.parseTextSync) === null || _wktLoader$parseTextS === void 0 ? void 0 : _wktLoader$parseTextS.call(wktLoader, geometry)) || null;
    case 'wkb':
    default:
      const wkbLoader = loaders.find(loader => loader.id === 'wkb');
      const arrayBuffer = ArrayBuffer.isView(geometry) ? geometry.buffer.slice(geometry.byteOffset, geometry.byteOffset + geometry.byteLength) : geometry;
      const geojson = wkbLoader === null || wkbLoader === void 0 ? void 0 : (_wkbLoader$parseSync = wkbLoader.parseSync) === null || _wkbLoader$parseSync === void 0 ? void 0 : _wkbLoader$parseSync.call(wkbLoader, arrayBuffer, {
        wkb: {
          shape: 'geojson-geometry'
        }
      });
      return geojson;
  }
}
//# sourceMappingURL=convert-table-to-geojson.js.map